import AlertPanel from 'ext-ui/components/AlertPanel/AlertPanel'
import React from 'react'
import { REQUIRED_FIELD_KEYS } from 'src/app/BulkInvite/bulkInvite.constants'
import { ExtendFieldKey } from 'src/app/BulkInvite/bulkInvite.types'
import ErrorState from 'src/app/BulkInvite/components/ErrorState'
import LoadingState from 'src/app/BulkInvite/components/LoadingState'
import MappingGrid from 'src/app/BulkInvite/components/MappingGrid'
import { useBulkInvite } from 'src/app/BulkInvite/context/BulkInviteContext'
import * as style from 'src/app/BulkInvite/steps/MappingStep.style'
import { useBulkInviteStrings } from 'src/app/BulkInvite/useBulkInviteStrings'

const FIELD_LABEL_KEY: Record<
  ExtendFieldKey,
  keyof ReturnType<typeof useBulkInviteStrings>
> = {
  firstName: 'fieldFirstName',
  lastName: 'fieldLastName',
  email: 'fieldEmail',
  phone: 'fieldPhone',
  role: 'fieldRole',
}

const MappingStep: React.FC = () => {
  const {
    mapping,
    savingMapping,
    mappingError,
    mappingErrorDetail,
    uploadWarnings,
  } = useBulkInvite()
  const strings = useBulkInviteStrings()

  if (savingMapping) {
    return <LoadingState title={strings.mappingSaving} />
  }

  if (mappingError) {
    return (
      <ErrorState
        title={strings.mappingError}
        // Surface the backend's actionable message; fall back to generic copy.
        detail={mappingErrorDetail ?? strings.mappingErrorDetail}
      />
    )
  }

  const missing = REQUIRED_FIELD_KEYS.filter((key) => !mapping[key])
  const missingLabels = missing
    .map((key) => strings[FIELD_LABEL_KEY[key]] as string)
    .join(', ')

  return (
    <div css={style.root}>
      {uploadWarnings.length > 0 && (
        <AlertPanel variant="warning">
          <div css={style.warnings}>
            {strings.mappingWarningsTitle}
            <ul css={style.warningsList}>
              {uploadWarnings.map((warning, i) => (
                <li key={i}>{warning}</li>
              ))}
            </ul>
          </div>
        </AlertPanel>
      )}

      {missing.length > 0 ? (
        <AlertPanel variant="warning">
          {strings.mappingMissingRequired(missingLabels)}
        </AlertPanel>
      ) : (
        <AlertPanel variant="default">
          {strings.mappingAllRequiredMapped}
        </AlertPanel>
      )}

      <MappingGrid />
    </div>
  )
}

export default MappingStep
